'use strict';

var createInstanceFromPrototype = Object.create || function(prototype) {
  var ctor = function() {};
  ctor.prototype = prototype;
  return new ctor;
};

module.exports = createInstanceFromPrototype;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/function/var/createInstanceFromPrototype.js
// module id = 645
// module chunks = 0